<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout row wrap fill-height>
          <TabVerificaNote v-if="bottomNav === 'verify-nota'"></TabVerificaNote>
          <TabNoteNonConfermate v-if="bottomNav === 'non-confermate-nota'"></TabNoteNonConfermate>
          <TabVerificaAuto v-if="bottomNav === 'verify-auto'"></TabVerificaAuto>
          <TabVerificaTratta
            v-if="bottomNav === 'verify-tratta'"
            @change-tratta-item="changeTrattaItemHandler"
            @toggle-tratta-item="toggleTrattaItemHandler"
          ></TabVerificaTratta>
      </v-layout>

    </v-container>
      <loading :show="isLoading" :label="textLoading"></loading>
    <v-bottom-nav :active.sync="bottomNav" class="primary" :value="true" fixed app>
      <v-btn value="verify-nota" class="tree--text">
        <span>Note</span>
        <v-badge :value="noteList.length > 0" color="purple" left overlap>
          <span slot="badge">{{noteList.length}}</span>
          <v-icon>list_alt</v-icon>
        </v-badge>
      </v-btn>
        
      <v-btn value="non-confermate-nota" class="tree--text">
        <span>Note non confermate</span>
        <v-badge :value="noteNonConfermate.length > 0" color="purple" left overlap>
          <span slot="badge">{{noteNonConfermate.length}}</span>
          <v-icon>list_alt</v-icon>
        </v-badge>
      </v-btn>

      <v-btn value="verify-auto" class="tree--text">
        <span>Auto</span>
        <v-badge :value="autoNonAggiornate.length > 0" color="purple" left overlap>
          <span slot="badge">{{autoNonAggiornate.length}}</span>
          <v-icon>fas fa-car</v-icon>
        </v-badge>
      </v-btn>

      <v-btn value="verify-tratta" class="tree--text">
        <span>Tratte</span>
        <v-badge :value="tratteSenzaKm.length > 0" color="purple" left overlap>
          <span slot="badge">{{tratteSenzaKm.length}}</span>
          <v-icon>fas fa-map-marker-alt</v-icon>
        </v-badge>
      </v-btn>
    </v-bottom-nav>
  </v-content>
</template>

<script>
import { GestioneSamm } from "../stores";
import {
  TabVerificaNote,
  TabVerificaAuto,
  TabVerificaTratta,
  TabNoteNonConfermate,
  Loading
} from "../components";

export default {
  name: "p-gestione",
  components: {
    TabVerificaNote,
    TabVerificaAuto,
    TabVerificaTratta,
    TabNoteNonConfermate,
    Loading
  },
  data() {
    return {
      showBadge: true,
      bottomNav: "verify-nota"
    };
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneSamm);
    }
  },
  watch: {},
  computed: {
    isLoading() {
      return this.$store.getters["gestione/loading"];
    },
    textLoading() {
      return this.$store.getters["gestione/textProcess"];
    },
    noteList() {
      return this.$store.getters["gestione/note"];
    },
    autoList() {
      return this.$store.getters["gestione/auto"];
    },
    autoNonAggiornate() {
      return this.$store.getters["gestione/autoNonAggiornate"];
    },
    tratteList() {
      return this.$store.getters["gestione/tratte"];
    },
    tratteSenzaKm() {
      return this.$store.getters["gestione/tratteSenzaKm"];
    },
    noteNonConfermate() {
      return this.$store.getters["gestione/noteNonConfermate"];
    },
  },
  created() {
    this.$store.dispatch("gestione/getNote");
    this.$store.dispatch("gestione/getAuto");
    this.$store.dispatch("gestione/getTratte");
    this.$store.dispatch("gestione/getNoteNonConfermate");
  },
  mounted() {},
  methods: {
    changeTrattaItemHandler(data) {
      this.$store.dispatch("gestione/changeTrattaItem", data);
    },
    toggleTrattaItemHandler(data) {
      this.$store.dispatch("gestione/toggleTrattaItem", data);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/GestioneSamm.vue